import React from 'react'
import PropTypes from 'prop-types'
import { StyledStatsCard } from './styled'

const StatsCard = (props) => {
	const {
		label, textColor,
		Icon, IconTablet, children,
		className, currency
	} = props

	return(
		<StyledStatsCard
			textColor={textColor}
			className={`${className} stats_wrapper`}
		>
			<div className='stats_card'>
				<div className='stats_card__icon'>
					<span><Icon className='computer_icon' /><IconTablet className='tablet_icon' /></span>
				</div>
				<div className='stats_card__label_value'>
					<div className='stats_card__label'>
						{label}
					</div>
					<div className='stats_card__value'>
						{children}
					</div>
				</div>
				{currency &&
					<div className='stats_card__currency'>
						{currency}
					</div>
				}
			</div>
		</StyledStatsCard>
	)
}

const { string, any, number, object, oneOfType } = PropTypes
StatsCard.propTypes = {
	label: string.isRequired,
	value: oneOfType([number, string, object]),
	icon: any,
	currency: string
}

export default StatsCard
